// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bTIuIIG2ysepF8 {
  flex: 0 0 36px;
  padding: var(--ds-space-025, 2px) var(--ds-space-100, 8px);
  border: 1px solid transparent;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
}
.bTIuIIG2ysepF8:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.BjkU3g0RnHJLIH {
  width: 16px;
  height: 16px;
}
`, ""]);
// Exports
export var menuButton = `bTIuIIG2ysepF8`;
export var blankIcon = `BjkU3g0RnHJLIH`;
export default ___CSS_LOADER_EXPORT___;
